// extracted by mini-css-extract-plugin
module.exports = {"item":"CourseProgram-module--item--3V97Z","title":"CourseProgram-module--title--3zM8J"};